import { Button, LoadSpinner } from '@calizahq/react-components-v2'
import { usePeopleFiltersContext } from '@sales-app/context/peopleFilters/peopleFilters'
import { useCorporateLeads } from '@sales-app/hooks/useCorporateLeads/useCorporateLeads'
import { BottomBar } from '@sales-app/views/BottomBar/BottomBar'
import React, { ChangeEvent, useMemo } from 'react'

import { BottomSheet, Table } from '@/components'
import { useToggle } from '@/hooks'

import { CorporateLeadListColumns } from './CorporateLeads.data'
import { CreateCorporateLeadForm } from './CreateCorporateLead/CreateCorporateLeadForm'

export const CorporateLeads = () => {
  const { setSearchString, searchString } = usePeopleFiltersContext()

  const { isShown: modalShown, toggle: modalToggle } = useToggle()
  const { data, refetch, isLoading } = useCorporateLeads()

  const onSearch = (e: ChangeEvent<HTMLInputElement>) => {
    e.preventDefault()
    setSearchString(e.target.value)
  }

  const corporateLeads = useMemo(() => {
    return data && data.corporateLeads ? data.corporateLeads : []
  }, [data])

  const columns = useMemo(() => {
    return CorporateLeadListColumns
  }, [])

  return (
    <>
      <div className="flex w-full flex-col p-4 md:p-8">
        <div className="mb-2 flex w-full items-center justify-between md:mb-4 md:flex-row">
          <h2 className=" text-header-lg leading-120">Corporate Leads</h2>
          <div className="hidden items-center md:flex">
            <Button className="bg-action-primary" onClick={modalToggle} size="small">
              Create Corporate Lead
            </Button>
          </div>
        </div>
        <div className="flex flex-col items-center pb-6 md:flex-row-reverse md:justify-end lg:flex-row">
          <input
            autoComplete="off"
            className="my-2 flex-1 rounded-lg border-2 border-border-secondary p-2 focus:outline-none md:my-0 md:w-auto md:flex-0"
            onChange={onSearch}
            placeholder="Search"
            value={searchString || ''}
          />
        </div>
        {isLoading ? (
          <div className="flex h-20 w-full items-center justify-center">
            <LoadSpinner className="icon-secondary" isCurrentColor={true} size={2} />
          </div>
        ) : (
          <>
            <Table columns={columns as any} data={corporateLeads} />
          </>
        )}
      </div>
      <BottomSheet isVisible={modalShown} mobileFullHeight={true} onClose={modalToggle}>
        <CreateCorporateLeadForm refetchOnSuccess={refetch} toggle={modalToggle} />
      </BottomSheet>
      <BottomBar />
    </>
  )
}
